
const contents = "query MultiTenantOrganizationDetails {\n  viewer {\n    multiTenantHubNetwork {\n      id\n      displayName\n      isMultiTenantNetwork\n    }\n  }\n}\n";
const sha256Hash = "99a632082b8bdea82367d8fda83571a114c476546008bcd20f3e367d93ae149d";
export default { contents: contents, sha256Hash: sha256Hash };
